import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  headline: validator('presence', true),
  type: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
});

export const settings = {
  copyableOptions: {
    ignoreAttributes: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
    ],
  },
  variantProperties: [
    'cmsLanguageId',
    'seoTitle',
    'seoDescription',
    'seoImage',
    'cmsState',
    'headline',
    'subHeadline',
    'teaserHeadline',
    'teaserSubHeadline',
    'text',
  ],
};

export default class CollectionModel extends Model.extend(Validations) {
  @attr('string') entitySubtype;
  @attr('string') headline;
  @attr('string') text;
  @attr('string') type;

  // CMS fields
  @attr('string') seoTitle;
  @attr('string') seoDescription;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('action', { async: true, inverse: null }) actions;
  @hasMany('article', { async: true, inverse: null }) articles;
  @hasMany('artist', { async: true, inverse: null }) artists;
  @hasMany('artist', { async: true, inverse: null }) artistTypes;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @hasMany('asset', { async: true, inverse: null }) assets;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;
  @hasMany('label', { async: true, inverse: null }) labels;
  @hasMany('live-event', { async: true, inverse: null }) liveEvents;
  @hasMany('media-embed', { async: true, inverse: null }) mediaEmbeds;
  @hasMany('media-event', { async: true, inverse: null }) mediaEvents;
  @hasMany('product', { async: true, inverse: null }) products;
  @hasMany('product-family', { async: true, inverse: null }) productFamilies;
  @hasMany('story', { async: true, inverse: null }) stories;
  @hasMany('teaser', { async: true, inverse: null }) teasers;
  @hasMany('web-series', { async: true, inverse: null }) webSeries;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return `${this.headline} (${this.id})`;
  }
}
